import axiosConfig from "./axiosConfig";

export interface ExtractedChargeItem {
  description: string;
  amount: number;
  type: "charge" | "consumption_adjustment";
}

export interface ExtractInvoiceChargesResponse {
  items: ExtractedChargeItem[];
}

const getExtractInvoiceCharges = async (
  authToken: string,
  siteId: string,
  fileGuid: string
): Promise<ExtractInvoiceChargesResponse> => {
  const { data } = await axiosConfig.get(
    `/site/${siteId}/invoice/extract_charges?fileGuid=${encodeURIComponent(fileGuid)}`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default getExtractInvoiceCharges;
